import { useSecureGraphqlMutation } from '@psyomics/ui-common';

import {
  UpdateSurveyResponseDocument,
  UpdateSurveyResponseInput,
  UpdateSurveyResponseMutation,
} from '../generated/survey-responses';

export const useUpdateSurveyResponse = () =>
  useSecureGraphqlMutation<
    UpdateSurveyResponseMutation,
    { input: UpdateSurveyResponseInput },
    'AttachmentValidationFailed' | 'SurveyNotFound' | 'SurveyResponseConflict'
  >(UpdateSurveyResponseDocument, [
    'AttachmentValidationFailed' as const,
    'SurveyNotFound' as const,
    'SurveyResponseConflict' as const,
  ]);
